export const BOT_ENV = {
  TEST: {
    title: `Test`,
    value: 'test',
    placeholder: 'Base url. e.g. https://staging.haptik.ai',
  },
  PRODUCTION: {
    title: `Production`,
    value: 'production',
    placeholder: 'Base url. e.g. https://production.haptik.ai',
  },
};

export const speedValuesBasedOnTtsProvider = [
  {
    min: 0.7,
    max: 1.2,
    default: 1.0,
  },
  {
    min: 0.5,
    max: 2,
    default: 1.1,
  },
  {
    min: -50,
    max: 50,
    default: 0.0,
    step: 0.5,
  },
];

// Maps TTS provider ID → the legacy bot_settings key that holds the custom Voice ID
// Only "Others"-style providers (free-text Voice ID) are listed here.
// 0 = ElevenLabs, 4 = Minimax, 5 = Cartesia
export const PROVIDER_VOICE_ID_KEY = {
  0: 'elevenlabs_voice_id',
  4: 'minimax_voice_id',
  5: 'cartesia_voice_id',
};

export const TAG_GENERATION_DEFAULT_PROMPT =
  '### Voice Response Optimization\n' +
  '\n' +
  'Always optimize responses for voice. Your responses will be spoken using ElevenLabs, so write ' +
  'naturally for speech rather than for reading. Use conversational phrasing, natural pacing, and ' +
  'appropriate emotional delivery. When useful, add ElevenLabs audio tags to guide emotion, tone, ' +
  'pacing, reactions, or delivery. The examples `[thoughtful]`, `[warmly]`, `[gently]`, `[excited]`, ' +
  '`[curious]`, `[hesitant]`, `[laughs]`, and `[sighs]` are illustrative, not an exhaustive list. Choose ' +
  'other appropriate tags when the context calls for them. Use tags selectively and only where they ' +
  'improve the naturalness of the spoken response.';

export const STATIC_TTS_SETTINGS = [
  {
    key: 'tts_voice_speed',
    title: 'TTS Voice Speed',
    type: 'slider',
    placeholder: null,
    info_text: 'Adjusts how fast or slow the generated speech is delivered. (Default: 1.1)',
    default: 1.1,
    min: 0.5,
    max: 2.0,
    min_label: '0.5',
    max_label: '2.0',
    visible_when: { field_key: 'tts_provider_id', in: [1, 2] },
  },
  {
    key: 'tts_voice_speed',
    title: 'TTS Voice Speed',
    type: 'slider',
    placeholder: null,
    info_text: 'Adjusts how fast or slow the generated speech is delivered. (Default: 1)',
    default: 1,
    min: 0.7,
    max: 1.2,
    min_label: '0.7',
    max_label: '1.2',
    visible_when: { field_key: 'tts_provider_id', in: [0] },
  },
  {
    key: 'tts_stability',
    title: 'TTS Stability',
    type: 'slider',
    placeholder: null,
    info_text: 'Controls consistency of tone and pacing across the speech. (Default: 0.5)',
    default: 0.5,
    min: 0,
    max: 1,
    min_label: '0',
    max_label: '1',
    visible_when: { field_key: 'tts_provider_id', in: [0] },
  },
  {
    key: 'tts_style',
    title: 'TTS Style',
    type: 'slider',
    placeholder: null,
    info_text: 'Adds expressive variation to the voice. (Default: 0.0)',
    default: 0,
    min: 0,
    max: 1,
    min_label: '0',
    max_label: '1',
    visible_when: { field_key: 'tts_provider_id', in: [0] },
  },
  {
    key: 'tts_similarity_boost',
    title: 'TTS Similarity Boost',
    type: 'slider',
    placeholder: null,
    info_text: 'Makes the output voice sound closer to the reference voice. (Default: 0.75)',
    default: 0.75,
    min: 0,
    max: 1,
    min_label: '0',
    max_label: '1',
    visible_when: { field_key: 'tts_provider_id', in: [0] },
  },
  {
    key: 'tts_use_speaker_boost',
    title: 'TTS Use Speaker Boost',
    type: 'toggle',
    placeholder: null,
    info_text: 'Enhances clarity and presence of the chosen speaker’s voice.',
    default: false,
    visible_when: { field_key: 'tts_provider_id', in: [0] },
  },
  {
    key: 'tts_tag_generation_prompt',
    title: 'Tag Generation Prompt',
    type: 'text',
    multiline: true,
    placeholder: null,
    info_text:
      'Instructs the agent to insert ElevenLabs v3/v4 expressive audio tags (e.g. [excited], [whispers]) ' +
      'into its spoken responses.',
    default: TAG_GENERATION_DEFAULT_PROMPT,
    visible_when: { field_key: 'tts_provider_id', in: [8, 9] },
  },
];
